export const TAGS = {
  mustReads: 600474,
  wallStreetBreakfast: 3340,
  investingIdeas: 10727,
  dividendsIncome: 16549,
  ETFsPortfolioStrategy: 11684,
  SATechStocks: 16993,
  todaysTranscripts: 49,
  FADaily: 562576,
} as const;
